/**
 * Outlet guard for the authenticated route branch. When the user is
 * not authenticated, redirects to ``/login?next=<pathname+search>``
 * with ``replace`` so the protected URL is not pushed onto history
 * (otherwise Back after sign-in would return to it pre-auth and loop).
 */

import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useAuth } from "../auth/AuthProvider";

export function RequireAuth(): JSX.Element {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  if (!isAuthenticated) {
    const target = `/login?next=${encodeURIComponent(location.pathname + location.search)}`;
    return <Navigate to={target} replace />;
  }
  return <Outlet />;
}
